import { WEEKDAYS, type AvailabilityDays, type Weekday } from "@shyne/shared/api";

export type DayOfWeek = Weekday;

export const DAYS_OF_WEEK: readonly DayOfWeek[] = WEEKDAYS;

export interface DaySchedule {
  enabled: boolean;
  start_time: string | null;
  end_time: string | null;
}

export type WeeklySchedule = Record<DayOfWeek, DaySchedule>;

export const weeklyScheduleOf = (days: AvailabilityDays): WeeklySchedule =>
  Object.fromEntries(
    DAYS_OF_WEEK.map((day) => {
      const hours = days[day];
      return [day, hours === null ? { enabled: false, start_time: null, end_time: null } : { enabled: true, start_time: hours.start, end_time: hours.end }];
    })
  ) as WeeklySchedule;

export const availabilityDaysOf = (schedule: WeeklySchedule): AvailabilityDays =>
  Object.fromEntries(
    DAYS_OF_WEEK.map((day) => {
      const { enabled, start_time, end_time } = schedule[day];
      return [day, enabled ? { start: start_time ?? "", end: end_time ?? "" } : null];
    })
  ) as AvailabilityDays;

export const isValidTimeRange = (startTime: string | null, endTime: string | null): boolean => {
  if (!startTime || !endTime) return false;
  return startTime < endTime;
};

export const validateDaySchedule = (daySchedule: DaySchedule): boolean => {
  if (!daySchedule.enabled) return true;
  return isValidTimeRange(daySchedule.start_time, daySchedule.end_time);
};

export const validateWeeklySchedule = (schedule: WeeklySchedule): boolean => DAYS_OF_WEEK.every((day) => validateDaySchedule(schedule[day]));
